export function onLocationSelect(value) {
  return {
    type: 'ON_LOCATION_SELECT',
    value
  };
}

export function onBrandSelect(value) {
  return {
    type: 'ON_BRAND_SELECT',
    value
  };
}

export function onNameInput(value) {
  return {
    type: 'ON_NAME_INPUT',
    value
  };
}

export function onPositionInput(value) {
  return {
    type: 'ON_POSITION_INPUT',
    value
  };
}

export function onDepartmentInput(value) {
  return {
    type: 'ON_DEPARTMENT_INPUT',
    value
  };
}

export function onPhoneInput(value) {
  return {
    type: 'ON_PHONE_INPUT',
    value
  };
}

export function onSubBrandChoice(value) {
  return {
    type: 'ON_SUB_BRAND_CHOICE',
    value
  };
}

export function onMobileNumberInput(value) {
  return {
    type: 'ON_MOBILE_NUMBER_INPUT',
    value
  };
}
export function onEmailInput(value) {
  return {
    type: 'ON_EMAIL_INPUT',
    value
  };
}


// WEBPACK FOOTER //
// ./src/actions/FormActions.js